import { Navigate } from 'react-router-dom';
import NuevaMatricula from '../components/auto-mat/NuevaMatricula';
import ListadoUsuarios from '../views/usuarios/ListadoUsuarios';
import DetallesUsuarios from '../views/usuarios/DetallesUsuarios';
import ServicioIntercambio from '../views/serviciointercambio/ServicioIntercambio';
import Actas from '../views/actas/Actas';
import Boletines from '../views/boletines/Boletines';
import Logs from '../views/logs/Logs';
import Solicitudes from '../views/matriculas/Solicitudes';
import Revision from '../views/matriculas/Revision';
import NuevoAlumno from '../views/usuarios/NuevoAlumno';
import MotorCalculo from '../views/motorcalculo/MotorCalculo';
import SuplantacionIdentidad from '../views/suplantacionidentidad/SuplantacionIdentidad';
import Ajustes from '../views/ajustes/Ajustes';
import ListadoRecibos from '../views/recibos/ListadoRecibos';
import ListadoFacturas from '../views/facturas/ListadoFacturas';
import DetallesFactura from '../views/facturas/DetallesFactura';
import NuevaFactura from '../views/facturas/NuevaFactura';
import FacturarRecibos from '../views/facturarRecibos/FacturarRecibos';

import PrivateRoute from '../layouts/hocs/PrivateRoute';
import { USER_ROLES } from '../helpers/constants';
import EnvioMailsWrapper from '../views/envioMails/EnvioEmailsWrapper';
import ImportarNotas from '../views/importarNotas/ImportarNotas';
import NotasAntiguoCampus from '../views/notasAntiguoCampus/NotasAntiguoCampus';
import Grupos from '../views/grupos/Grupos';
import DetallesGrupos from '../views/grupos/DetallesGrupos';

import ListadoProfesores from '../views/profesores/ListadoProfesores';
import DetallesProfesores from '../views/profesores/DetallesProfesores';
import CrearProfesores from '../views/profesores/CrearProfesor';
import ListadoClientes from '../views/clientes/ListadoClientes';
import FichaCliente from '../views/clientes/FichaCliente';
import NuevoCliente from '../views/clientes/NuevoCliente';
import Presupuestos from '../views/presupuestos/Presupuestos';
import NuevoPresupuesto from '../views/presupuestos/NuevoPresupuesto';
import DetallePresupuesto from '../views/presupuestos/DetallePresupuesto';
import Descuentos from '../views/descuentos/Descuentos';
import Precios from '../views/precios/Precios';
import Tickets from '../views/tickets/Tickets';
import config from '../config';

/*****Routes******/

// Acceso permitido a cualquier usuario autenticado con rol reconocido. Mantiene
// fuera a sesiones sin rol válido (getUserRol() === undefined) y documenta la
// intención de forma explícita, alineada con la visibilidad del menú lateral.
// El backend sigue siendo la autoridad final sobre cada endpoint.
const ALL_ROLES = [
  USER_ROLES.SUPERADMIN,
  USER_ROLES.SEDE,
  USER_ROLES.ORIENTACION,
  USER_ROLES.SECRETARIA,
  USER_ROLES.DELEGACION,
];

const ThemeRoutes = [
  {
    path: '/',
    exact: true,
    element: <Navigate to="/alumnos" />,
  },
  {
    path: '/alumnos',
    exact: true,
    element: (
      <PrivateRoute roles={ALL_ROLES}>
        <ListadoUsuarios />
      </PrivateRoute>
    ),
  },
  {
    path: '/alumnos/:empresaId/:studentId/detalles',
    exact: true,
    element: (
      <PrivateRoute roles={ALL_ROLES}>
        <DetallesUsuarios />
      </PrivateRoute>
    ),
  },
  {
    path: '/servicio-de-intercambio',
    exact: true,
    element: (
      <PrivateRoute roles={[USER_ROLES.SUPERADMIN, USER_ROLES.SEDE, USER_ROLES.SECRETARIA]}>
        <ServicioIntercambio />
      </PrivateRoute>
    ),
  },
  {
    path: '/actas',
    exact: true,
    element: (
      <PrivateRoute roles={[USER_ROLES.SUPERADMIN, USER_ROLES.SEDE, USER_ROLES.SECRETARIA]}>
        <Actas />
      </PrivateRoute>
    ),
  },
  {
    path: '/boletines',
    exact: true,
    element: (
      <PrivateRoute roles={[USER_ROLES.SUPERADMIN, USER_ROLES.SEDE, USER_ROLES.SECRETARIA]}>
        <Boletines />
      </PrivateRoute>
    ),
  },
  {
    path: '/matriculas/nueva',
    exact: true,
    element: (
      // TODO: Revisar las permisiones de esta ruta con Javi.
      <PrivateRoute
        roles={[
          USER_ROLES.SUPERADMIN,
          USER_ROLES.DELEGACION,
          USER_ROLES.SEDE,
          USER_ROLES.SECRETARIA,
        ]}
      >
        <NuevaMatricula variant="admin" deployment={config.REACT_APP_DEPLOYMENT} />
      </PrivateRoute>
    ),
  },
  {
    path: '/solicitudes-matricula',
    exact: true,
    element: (
      <PrivateRoute roles={ALL_ROLES}>
        <Solicitudes />
      </PrivateRoute>
    ),
  },
  {
    path: '/solicitudes-matricula/:empresaId/:matriculaId/revision/',
    exact: true,
    element: (
      <PrivateRoute roles={ALL_ROLES}>
        <Revision />
      </PrivateRoute>
    ),
  },
  {
    path: '/logs',
    exact: true,
    element: (
      <PrivateRoute roles={[USER_ROLES.SUPERADMIN]}>
        <Logs />
      </PrivateRoute>
    ),
  },
  {
    path: '/envio-mails',
    exact: true,
    element: (
      <PrivateRoute roles={[USER_ROLES.SUPERADMIN, USER_ROLES.SECRETARIA]}>
        <EnvioMailsWrapper />
      </PrivateRoute>
    ),
  },
  {
    path: '/nuevo-alumno',
    exact: true,
    element: (
      <PrivateRoute roles={ALL_ROLES}>
        <NuevoAlumno />
      </PrivateRoute>
    ),
  },
  {
    path: '/calculo-notas',
    exact: true,
    element: (
      <PrivateRoute roles={[USER_ROLES.SUPERADMIN]}>
        <MotorCalculo />
      </PrivateRoute>
    ),
  },
  {
    path: '/suplantacion-identidad',
    exact: true,
    element: (
      <PrivateRoute roles={[USER_ROLES.SUPERADMIN]}>
        <SuplantacionIdentidad />
      </PrivateRoute>
    ),
  },
  {
    path: '/importar-notas',
    exact: true,
    element: (
      <PrivateRoute roles={[USER_ROLES.SUPERADMIN]}>
        <ImportarNotas />
      </PrivateRoute>
    ),
  },
  {
    path: '/notas-antiguo-campus',
    exact: true,
    element: (
      <PrivateRoute roles={[USER_ROLES.SUPERADMIN, USER_ROLES.SEDE, USER_ROLES.SECRETARIA]}>
        <NotasAntiguoCampus />
      </PrivateRoute>
    ),
  },
  {
    path: '/grupos',
    exact: true,
    element: (
      <PrivateRoute roles={[USER_ROLES.SUPERADMIN, USER_ROLES.SECRETARIA, USER_ROLES.SEDE]}>
        <Grupos />
      </PrivateRoute>
    ),
  },
  {
    path: '/grupos/detalles/:empresaId/:id',
    exact: true,
    element: (
      <PrivateRoute roles={[USER_ROLES.SUPERADMIN, USER_ROLES.SECRETARIA, USER_ROLES.SEDE]}>
        <DetallesGrupos />
      </PrivateRoute>
    ),
  },
  {
    path: '/presupuestos',
    exact: true,
    element: (
      <PrivateRoute
        roles={[USER_ROLES.SUPERADMIN]}
        allowedEmails={[
          'asanjose@cedetecgroup.com',
          'nfeneux@cedetecgroup.com',
          'ajimenez@cedetecgroup.com',
        ]}
      >
        <Presupuestos />
      </PrivateRoute>
    ),
  },
  {
    path: '/presupuestos/nuevo',
    exact: true,
    element: (
      <PrivateRoute
        roles={[USER_ROLES.SUPERADMIN]}
        allowedEmails={[
          'asanjose@cedetecgroup.com',
          'nfeneux@cedetecgroup.com',
          'ajimenez@cedetecgroup.com',
        ]}
      >
        <NuevoPresupuesto />
      </PrivateRoute>
    ),
  },
  {
    path: '/presupuestos/:headquarter/:id',
    exact: true,
    element: (
      <PrivateRoute
        roles={[USER_ROLES.SUPERADMIN]}
        allowedEmails={[
          'asanjose@cedetecgroup.com',
          'nfeneux@cedetecgroup.com',
          'ajimenez@cedetecgroup.com',
        ]}
      >
        <DetallePresupuesto />
      </PrivateRoute>
    ),
  },
  {
    path: '/descuentos',
    exact: true,
    element: (
      <PrivateRoute
        roles={[USER_ROLES.SUPERADMIN]}
        allowedEmails={[
          'asanjose@cedetecgroup.com',
          'nfeneux@cedetecgroup.com',
          'ajimenez@cedetecgroup.com',
        ]}
      >
        <Descuentos />
      </PrivateRoute>
    ),
  },
  {
    // Consulta para staff; la edicion la autoriza el backend (403 si no es admin).
    path: '/precios',
    exact: true,
    element: (
      <PrivateRoute roles={[USER_ROLES.SUPERADMIN, USER_ROLES.SEDE, USER_ROLES.SECRETARIA]}>
        <Precios />
      </PrivateRoute>
    ),
  },
  {
    path: '/ajustes',
    exact: true,
    element: (
      <PrivateRoute roles={[USER_ROLES.SUPERADMIN]}>
        <Ajustes />
      </PrivateRoute>
    ),
  },
  {
    path: '/recibos',
    exact: true,
    element: (
      <PrivateRoute roles={[USER_ROLES.SUPERADMIN]}>
        <ListadoRecibos />
      </PrivateRoute>
    ),
  },
  {
    path: '/facturas',
    exact: true,
    element: (
      <PrivateRoute roles={[USER_ROLES.SUPERADMIN]}>
        <ListadoFacturas />
      </PrivateRoute>
    ),
  },
  {
    path: '/facturas/nueva',
    exact: true,
    element: (
      <PrivateRoute roles={[USER_ROLES.SUPERADMIN]}>
        <NuevaFactura />
      </PrivateRoute>
    ),
  },
  {
    path: '/facturas/:empresaId/:id/detalles',
    exact: true,
    element: (
      <PrivateRoute roles={[USER_ROLES.SUPERADMIN]}>
        <DetallesFactura />
      </PrivateRoute>
    ),
  },
  {
    path: '/facturar-recibos',
    exact: true,
    element: (
      <PrivateRoute roles={[USER_ROLES.SUPERADMIN]}>
        <FacturarRecibos />
      </PrivateRoute>
    ),
  },
  {
    path: '/profesores',
    exact: true,
    element: (
      <PrivateRoute roles={[USER_ROLES.SUPERADMIN, USER_ROLES.SEDE, USER_ROLES.SECRETARIA]}>
        <ListadoProfesores />
      </PrivateRoute>
    ),
  },
  {
    path: '/profesores/:empresaId/:profesoresId/detalles',
    exact: true,
    element: (
      <PrivateRoute roles={[USER_ROLES.SUPERADMIN, USER_ROLES.SEDE, USER_ROLES.SECRETARIA]}>
        <DetallesProfesores />
      </PrivateRoute>
    ),
  },
  {
    path: '/profesores/nuevo',
    exact: true,
    element: (
      <PrivateRoute roles={[USER_ROLES.SUPERADMIN, USER_ROLES.SEDE, USER_ROLES.SECRETARIA]}>
        <CrearProfesores />
      </PrivateRoute>
    ),
  },
  {
    path: '/clientes',
    exact: true,
    element: (
      <PrivateRoute roles={[USER_ROLES.SUPERADMIN]}>
        <ListadoClientes />
      </PrivateRoute>
    ),
  },
  {
    path: '/clientes/nuevo',
    exact: true,
    element: (
      <PrivateRoute roles={[USER_ROLES.SUPERADMIN]}>
        <NuevoCliente />
      </PrivateRoute>
    ),
  },
  {
    path: '/clientes/:headquarter/:ccodcli/detalles',
    exact: true,
    element: (
      <PrivateRoute roles={[USER_ROLES.SUPERADMIN]}>
        <FichaCliente />
      </PrivateRoute>
    ),
  },
  {
    // Seccion opcional: /tickets, /tickets/:id (detalle), /tickets/nuevo,
    // /tickets/informes, /tickets/respuestas, /tickets/bloqueos. La vista valida el segmento.
    path: '/tickets/:seccion?',
    exact: true,
    // Soporte (tickets): SUPERADMIN y SECRETARIA (visibilidad alineada con el
    // menu lateral).
    element: (
      <PrivateRoute roles={[USER_ROLES.SUPERADMIN, USER_ROLES.SECRETARIA]}>
        <Tickets />
      </PrivateRoute>
    ),
  },
];

export default ThemeRoutes;
